import * as React from 'react';
import * as NotificationsStore from "../../../store/NotificationsStore";
import { Dictionary } from '../../../entities/common';
import { ExtensionInfo } from '../../../store/ExtensionStore';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { tryGetUrl } from '../EmbeddedContent/EmbeddedContent';

export type OwnProps = {
    onDismiss: () => void;
    info: ExtensionInfo;
    context: Dictionary<any>;
};

type ActionProps = {
    notificationActions: typeof NotificationsStore.actionCreators;
};

type Props = OwnProps & ActionProps;

const ExtensionNavigate = (props: Props) => {
    const { onDismiss, context, notificationActions } = props;
    const urlStr = props.info.url;
    React.useEffect(() => {
        const result = tryGetUrl(urlStr, context);

        if (!result.success || !result.value) {
            notificationActions.pushNotification({ message: `Extension is not configured well.`, type: NotificationsStore.NotificationType.Error });
            onDismiss();
            return;
        }

        window.open(result.value.toString(), '_blank');
        onDismiss();
    }, [urlStr, context, notificationActions, onDismiss]);

    return null;
};

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        notificationActions: bindActionCreators(NotificationsStore.actionCreators, dispatch)
    };
}

export default connect(undefined, mergeActionCreators)(ExtensionNavigate);
